import { render, staticRenderFns } from "./Staff_Roster.vue?vue&type=template&id=da518fbe&scoped=true&"
import script from "./Staff_Roster.vue?vue&type=script&lang=js&"
export * from "./Staff_Roster.vue?vue&type=script&lang=js&"
import style0 from "./Staff_Roster.vue?vue&type=style&index=0&id=da518fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da518fbe",
  null
  
)

export default component.exports